<template>


  <el-drawer custom-class="bottom_drop_up applicant-list" v-model="modalVisible" :append-to-body="true"
    :direction="'btt'" :title="`${shift.shiftApplications.length} ${shift.shiftApplications.length === 1 ? 'Applicant' : 'Applicants'}`" :destroy-on-close="true" data-testid="more-bottom-drop-up-drawer">
   
    <template v-if="shift.shiftApplications.length > 0 ">
      <div class="avatar-row avatar-row--col" v-for="(locumItem, i) in shift.shiftApplications"
        v-bind:key="locumItem.id">
        <div class="avatar-row-left" style="cursor: pointer;" @click="openApplicantActions(locumItem, i)">
          <template v-if="locumItem.locum">
            <el-avatar :size="'small'" shape="circle" :src="locumItem.locum.image" v-if="locumItem.locum.image != null" />
            <el-avatar :size="'small'" class="avatar-d d-inline-block" shape="circle"
              icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
          </template>
          <p>
            <span v-if="locumItem.status === 9">{{ locumFullName(locumItem.locum) }} ({{ locumItem.statusLabel }})</span>
            <span v-else>{{ locumFullName(locumItem.locum) || 'Unknown locum' }}</span>
            <br>
            <span class="text-secondary" style="font-size: 15px;">
              Locum rate: {{ formatCurrency(locumItem.locumRate) }}/hr
            </span>
          </p>
        </div>

        <applicant-actions-sheet
          v-model="bottomDropUp[i]"
          :locum="locumItem.locum"
          :locum-rate="locumItem.locumRate"
          :show-shift-actions="userRole == 'pharmacy'"
          :show-preferences="userRole == 'pharmacy'"
          :show-chat="userRole == 'pharmacy'"
          @offer="openAwardShiftDialog(locumItem, i, shift, job)"
          @decline="rejectApplicant(locumItem, i, shift, job)"
          @chat="closeModal"
        />
      </div>
    </template>
    <template v-else>
      There are no applicants for this shift.
    </template>
  </el-drawer>
 

  <modal-user-info :modalName="'sepratePreviewModal'" :options="sepratePreviewModal"></modal-user-info>
  <cert-preview-modal :modalName="'certPreviewModald'" :options="certPreviewModal"></cert-preview-modal>
</template>
  
  <script>
  import { ref, inject,computed } from "vue";
  import moment from "moment";
  import { useStore } from "vuex";
  // import { SepratePreviewModal } from "@/modals/modals";
  import { ElMessageBox,ElMessage } from "@/components/Vendor/Element";
  import { useRouter } from "vue-router";
  import CertPreviewModal from "../CovidCertModal/CertificatePreviewModal.vue";
  import SepratePreviewModal from "../User/Applicant/SepratePreviewModal.vue"
  import ApplicantActionsSheet from "@/components/ApplicantActions/ApplicantActionsSheet.vue"
  export default {
    props: {
      modalName: {
        type: String,
      },
      options: {
        type: Object,
      },
    },
    components: {
      "modal-user-info": SepratePreviewModal,
      "cert-preview-modal": CertPreviewModal,
      "applicant-actions-sheet": ApplicantActionsSheet,
    },
    setup(props) {
      const $store = useStore();
      const $router = useRouter();
      const $mitt = inject("$mitt");
      const $modals = inject("$modals");
      const modalVisible = ref(false);
      const bottomDropUp = ref([]);
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role; 
      const $moment = inject(["$moment"]);
      // const showAwardShiftDialog = ref(false);
      const closeModal = () => {
        modalVisible.value = false;
      };
      $mitt.on(props.modalName, (options) => {
        modalVisible.value = options.show;
      });
      // const openModal = () => {};
      const dialogTitle = computed(() => {
        return `${checkJobDateStart(job.value.startDate, job.value.endDate, true)}`;
      // if (checkJobDateStart(job.value.startDate, job.value.endDate)) {
        
      // } else {
      //   return moment(job.value.endDate, "YYYY/MM/DD").format("D MMM");
      // }
    });

    const openPdf = (file) => {
      window.open(file.url, "_blank");
    };

    const ensureApplicantDocuments = async (locumItem) => {
      if (!locumItem?.locum || (locumItem.locum.locumCvs && locumItem.locum.locumCvs.length > 0)) {
        return;
      }
      try {
        const resp = await $store.dispatch("GET_AWARD_SHIFT_DETAIL_INFO", {
          shiftAppId: locumItem.id,
          pharmacyId: userData.id,
          locumId: locumItem.userId || locumItem.locum.id,
          hideLoading: true,
        });
        const detailedLocum = resp?.data?.locum;
        if (detailedLocum) {
          locumItem.locum = {
            ...locumItem.locum,
            ...detailedLocum,
            locumCvs: detailedLocum.locumCvs || detailedLocum.locum_cvs || [],
            covidCertPro: detailedLocum.covidCertPro || detailedLocum.covid_cert_pro || [],
            insuranceDocument: detailedLocum.insuranceDocument || detailedLocum.insurance_document || [],
            otherInsuranceDocument:
              detailedLocum.otherInsuranceDocument ||
              detailedLocum.other_insurance_document ||
              [],
          };
        }
      } catch (e) {
        console.error("Failed to load applicant documents", e);
      }
    };

    const openApplicantActions = async (locumItem, i) => {
      bottomDropUp.value[i] = true;
      await ensureApplicantDocuments(locumItem);
    };

    const formatCurrency = (rate) => {
      return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(rate);
    };

    const locumFullName = (locum) => {
      if (!locum) {
        return "";
      }
      const first = (locum.name || "").trim();
      const last = (locum.lastName || locum.last_name || "").trim();
      if (!last || first.toLowerCase().endsWith(last.toLowerCase())) {
        return first;
      }
      return `${first} ${last}`.trim();
    };

    const sepratePreviewModal = ref({
      name: "userInfo",
      user: {},
    });

    const actions = {
      async sepratePreviewModalOpen(locumObj) {
          bottomDropUpClose();
          await ensureApplicantDocuments(locumObj);
          sepratePreviewModal.value.user = locumObj.locum;
          $modals.open("sepratePreviewModal");
      },
    }
      const checkJobDateStart = (dateStart, endDate, trim) => {
        let start = moment(dateStart, "YYYY/MM/DD");
        let end = moment(endDate, "YYYY/MM/DD");
        if (start.format("MMMM") == end.format("MMMM")) {
          if (start.format("D") == end.format("D")) {
            return start.format("D " + (trim ? "MMM" : "MMMM"));
          }
          return (
          start.format("D ") +
          " - " +
          end.format("D " + (trim ? "MMM" : "MMMM"))
        );
        } else {
          return (
            start.format("D " + (trim ? "MMM" : "MMMM")) +
            " - " +
            end.format("D " + (trim ? "MMM" : "MMMM"))
          );
        }
    };

    const job = computed(() => {
      return props.options.job;
    });

    const shift = computed(() => {
      return props.options.shift;
    });

    console.log("SHIFT:", shift)

    const bottomDropUpClose = (i) => {
      bottomDropUp.value[i] = false;
    };

 

    const rejectApplicant = async (locumItem, i,shift,job) =>{
      bottomDropUpClose(i);
      console.log("🚀 ~ rejectApplicant ~ shift:", shift)
      console.log("🚀 ~ rejectApplicant ~ locumItem:", locumItem)
      try {
        if(job.isBlockShift === 1){
          let startDate = checkJobDateStart(job.startDate, job.endDate, true);
          await ElMessageBox.confirm(
          `Are you sure you want to decline ${locumItem.locum.name} from the ${startDate} shift.`,
          "Decline applicant",
          {
            confirmButtonText: "Decline",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--green",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );
        }else{
          await ElMessageBox.confirm(
          `Are you sure you want to decline ${locumItem.locum.name} from the ${$moment(
                shift.date,
                "YYYY/MM/DD"
              ).format("dddd, D MMMM")} shift.`,
          "Decline applicant",
          {
            confirmButtonText: "Decline",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--green",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );
        }
       

        await (async () => {
          try {
            console.log("after accept",locumItem);
            // Your asynchronous operations here...
              await $store.dispatch("REJECT_APPLICANT_BY_PHARMACY", {
                application_id: locumItem.id,
              });
            

            ElMessage({
              type: "success",
              message: "Applicant removed successfully",
            });
            modalVisible.value= false;
          //call

          const job = await $store.dispatch("GET_JOB_INFO_DETAILS", {
                                    jobId: shift.jobId,
                                    params: {
                                        with:
                                            "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                                    },
                                });
                                console.log("🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:", job)
                            
                                $store.dispatch('clearJobDetails');
                                $store.dispatch("setJobDetails", {
                                    job: job.data,
                                });
                                $router.push({
                                  name: "job_days",
                                });



          //end call
            
          } catch (error) {
            ElMessage({
              type: "info",
              message: "Shift did not rewared",
            });
            console.log("error submit!!");
          }
        })();
      } catch (error) {
        console.log(error);
      }
    }

    const openAwardShiftDialog = async (locumItem, i,shift,job) => {
    console.log("🚀 ~ file: ApplicationsPreviewModal.vue:278 ~ openAwardShiftDialog ~ job:", job)
    console.log("🚀 ~ file: ApplicationsPreviewModal.vue:278 ~ openAwardShiftDialog ~ shift:", shift)

    // This function is called when the "Award Shift" button is clicked
    // closeModal();
    bottomDropUpClose(i);
    // openDialog();
    // showAwardShiftDialog.value = true;

    try {
      if(job.isBlockShift === 1){

        await ElMessageBox.confirm(
          `This shift is part of a block shift scheduled from <strong>${dialogTitle.value}</strong>, and assigning this shift will also allocate all the related shifts to ${locumItem.locum.name}`,
          "Offer Shift",
          {
            confirmButtonText: "Approve",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--green",
            cancelButtonClass: "el-button--grey",
            showClose: false,
            dangerouslyUseHTMLString: true,
          }
        );

      }else{
        await ElMessageBox.confirm(
          `Are you sure you want to offer the shift to ${locumItem.locum.name}?`,
          "Offer Shift",
          {
            confirmButtonText: "Approve",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--green",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );
      }
    

      await (async () => {
        try {
          console.log("after accept",locumItem);
          // Your asynchronous operations here...
            await $store.dispatch("AWARD_SHIFT", {
              application_id: locumItem.id,
            });
          

          ElMessage({
            type: "success",
            message: "Shift Offered successfully",
          });
          modalVisible.value= false;
        //call

        const job = await $store.dispatch("GET_JOB_INFO_DETAILS", {
                                  jobId: shift.jobId,
                                  params: {
                                      with:
                                          "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                                  },
                              });
                              console.log("🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:", job)
                          
                              $store.dispatch('clearJobDetails');
                              $store.dispatch("setJobDetails", {
                                  job: job.data,
                              });
                              $router.push({
                                name: "job_days",
                              });



        //end call
          
        } catch (error) {
          ElMessage({
            type: "info",
            message: "Shift did not Offered",
          });
          console.log("error submit!!");
        }
      })();
    } catch (error) {
      console.log(error);
    }
};

    const openModal = () => {
   

      const shiftJob = {...shift.value.job}
      console.log("SHIFT:", shift.value)
      console.log('JOB:', shiftJob)
    };

    const certPreviewModal = ref({
        name: "certPrev",
        file: [],
      });

    const certPreviewModalOpen = (file) => {
        if(file.extension == 'pdf'){
          window.open(file.url, '_blank');
        }else{
        certPreviewModal.value.file = file;
  
  
        $modals.open("certPreviewModal", {
          file: file,
        });
  
        console.log("end osf posspup")
      }
      };

      return {
        closeModal,
        modalVisible,
        openModal,
        checkJobDateStart,
        job,
        shift,
        bottomDropUp,
        dialogTitle,
        userData,
        userRole,
        // showAwardShiftDialog,
        // openDialog,
        // closeDialog,
        // awardShift,
        openAwardShiftDialog,
        bottomDropUpClose,
        sepratePreviewModal,
        actions,
        rejectApplicant,
        certPreviewModalOpen,
        certPreviewModal,
        formatCurrency,
        locumFullName,
        openPdf,
        openApplicantActions,
      };
    },
  };
  </script>
<style lang="scss">
  .open-pdf {
    span {
      justify-content: end;
    }
  }
</style>